import { State } from "../../types";

export type MarkBlockActiveAction = Readonly<{
  blockId?: string;
  type: "MARK BLOCK ACTIVE";
}>;

export const markBlockActive = (state: State, action: MarkBlockActiveAction): State => {
  if (state.selectedBlockId === action.blockId || state.readonly) {
    return state;
  }
  return {
    ...state,
    scrollToPageBlock: action.blockId,
    selectedBlockId: action.blockId,
  };
};
